// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const WarningFailedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="WarningFailedIcon" ref={forwardedRef} {...props}>
      <path d="m11.39 14.7-1.415-1.414L8.56 14.7 7.5 13.64l1.414-1.415L7.5 10.81l1.06-1.06 1.415 1.414 1.414-1.414 1.06 1.06-1.413 1.415 1.414 1.414z" />
      <path d="M8.595 3.654c.45-.851.676-1.277.975-1.42a1 1 0 0 1 .86 0c.299.143.524.569.975 1.42l6.36 12.012c.403.762.604 1.143.567 1.454a1 1 0 0 1-.422.701C17.652 18 17.22 18 16.36 18H3.64c-.861 0-1.292 0-1.55-.179a1 1 0 0 1-.422-.701c-.037-.311.164-.692.568-1.454zM16.509 16.5 10 4.206 3.491 16.5z" />
    </SvgIcon>
  );
});

/**
 * Use to show failed processes
 * @public
 */
export const WarningFailedIcon = /* @__PURE__ */ Object.assign(
  WarningFailedIconComponent,
  { displayName: 'WarningFailedIcon' },
);
